import { SEO_SERVICE_BASE_URL } from '../config'
import axios from '../../function/axiosInstance'
import extract from '../../function/extract'

type Args = {
  companyId: string
  projectId: string
  domainId: string
}

export const attachDomainWithProject = async ({
  companyId,
  projectId,
  domainId
}: Args) => {
  try {
    const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/projects/v2/bind`
    const response = await axios.post(url, {
      project_id: projectId,
      domain_id: domainId
    })
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}
